function Connectivity(state) {

    var self = this;
    var disconnectedRequests = [];

    // Observables
    self.appOffline = ko.observable(false);
    self.connected = ko.observable(state || true);
    self.statusCode = ko.observable(0);

    // Subscribes
    self.connected.subscribe(function (newValue) {
        if (newValue) {
            processRequestQueue();
        }
    });

    // Public functions
    self.queueRequest = function(ajaxData) {
        if (ajaxData && ajaxData.queueKey) {
            disconnectedRequests[ajaxData.queueKey] = ajaxData;
        }
    }

    //Private functions
    function processRequestQueue() {
        var requestQueue = disconnectedRequests;
        disconnectedRequests = [];
        cccApp.api.processRequestQueue(requestQueue);
    }
}